// extracted by mini-css-extract-plugin
export var border__top = "Footer-module--border__top--fc9f8";
export var column__container = "Footer-module--column__container--8b380";
export var column__content = "Footer-module--column__content--fd954";
export var container_form = "Footer-module--container_form--0d513";
export var container_response = "Footer-module--container_response--3226e";
export var copyright = "Footer-module--copyright--a5ff1";
export var divider = "Footer-module--divider--c57a6";
export var divider2 = "Footer-module--divider2--a4ba2";
export var finalrow__container = "Footer-module--finalrow__container--d050c";
export var finalrow__content = "Footer-module--finalrow__content--3b829";
export var links = "Footer-module--links--f1505";
export var list = "Footer-module--list--c11e4";
export var main_container_form = "Footer-module--main_container_form--8e34d";
export var newsletter__button = "Footer-module--newsletter__button--863e3";
export var newsletter__container = "Footer-module--newsletter__container--a3165";
export var newsletter__input = "Footer-module--newsletter__input--7c8ab";